<template>
    <nav class="navbar navbar-expand-lg bg-primary border-0 fixed-top py-md-4 shadow-lg">
        <div class="container px-3 px-xl-6">
            <div class="navbar-brand">
                <inertia-link :href="route('nft.collection.show')">
                    <img alt="Hada" src="/hadanft-logo.svg" class="Logo" width="156">
                </inertia-link>
            </div>
            <div class="d-flex align-items-center">
                <div v-if="$page.props.user" class="dropdown me-1 d-lg-none">
                    <div id="mobileNavbarDropdown" class="owner-avatar position-relative dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown"
                         aria-expanded="false" role="button">
                        <a href="#" class="nav-link p-0 position-relative rounded-circle overflow-hidden border border-4 border-white shadow">
                            <img :src="profileImage" alt="owner avatar" class="h-100 w-100">
                        </a>
                        <span v-if="wtfOwner"
                              class="owner-tag pb-2 pt-3 wtf-owner-tooltip position-absolute text-white bg-secondary rounded-1 fw-bold fs-8 text-center"
                              data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Discounts available when you see this sign!">
                            WTF <br> Owner
                        </span>
                    </div>
                    <ul aria-labelledby="mobileNavbarDropdown"
                        class="dropdown-menu dropdown-menu-end p-0 bg-primary rounded-1 border border-primary-200">
                        <li>
                            <form :action="route('logout')" method="POST">
                                <input :value="$page.props.csrf" name="_token" type="hidden"/>
                                <button class="btn btn-primary-300 p-2 w-100 text-white" type="submit">
                                    <svg class="me-2" height="24" width="24">
                                        <use xlink:href="#logout"></use>
                                    </svg>
                                    Sign out
                                </button>
                            </form>
                        </li>
                    </ul>
                </div>
                <button aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
                        class="navbar-toggler text-white" data-bs-target="#navbarSupportedContent"
                        data-bs-toggle="collapse" type="button">
                    <svg width="32" height="32">
                        <use xlink:href="#menu-icon"></use>
                    </svg>
                </button>
            </div>
            <div id="navbarSupportedContent" class="collapse navbar-collapse justify-content-end">
                <ul class="navbar-nav mb-2 mb-lg-0 pt-3 pt-lg-0">
                    <li class="nav-item mx-lg-4">
                        <a :class="{ 'active': route().current('offers') }"
                           :href="route('offers')" class="nav-link px-0 fw-bold fs-18 fw-semibold text-white">
                            Offers
                        </a>
                    </li>
                    <li class="nav-item mx-lg-4">
                        <a :class="{ 'active': route().current('wallet') }"
                           :href="route('wallet')" class="nav-link px-0 fw-bold fs-18 fw-semibold text-white">
                            Wallet
                        </a>
                    </li>
                    <li class="nav-item mx-lg-4">
                        <a :class="{ 'active': route().current('nft.collection.show') || route().current('nft.*') }"
                           :href="route('nft.collection.show')" class="nav-link px-0 fw-bold fs-18 fw-semibold text-white">
                            NFT
                        </a>
                    </li>
                    <li v-if="$page.props.user" class="nav-item dropdown ms-4 d-none d-lg-block">
                        <div id="navbarDropdown" class="owner-avatar position-relative dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown"
                             aria-expanded="false" role="button">
                            <a href="#" class="nav-link p-0 position-relative rounded-circle overflow-hidden border border-4 border-white shadow">
                                <img :src="profileImage" alt="owner avatar" class="h-100 w-100">
                            </a>
                            <span v-if="wtfOwner"
                                  class="owner-tag pb-2 pt-5 wtf-owner-tooltip position-absolute text-white bg-secondary rounded-1 fw-bold fs-10 text-center"
                                  data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Discounts available when you see this sign!">
                                WTF <br> Owner
                            </span>
                        </div>
                        <ul aria-labelledby="navbarDropdown"
                            class="dropdown-menu dropdown-menu dropdown-menu-end p-0 bg-primary rounded-1 border border-primary-200">
                            <li>
                                <form :action="route('logout')" method="POST">
                                    <input :value="$page.props.csrf" name="_token" type="hidden"/>
                                    <button class="btn btn-primary-300 w-100 p-2 text-white" type="submit">
                                        <svg class="me-2" height="24" width="24">
                                            <use xlink:href="#logout"></use>
                                        </svg>
                                        Sign out
                                    </button>
                                </form>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import Tooltip from '@/Mixins/Tooltip'

export default {
	name: 'TopBar',

	props: {
		title: String,
		subtitle: String,
		wtfOwner: {
			type: Boolean,
			default: false
		}
	},

	mixins: [Tooltip],

	computed: {
		profileImage() {
			return this.$page.props.user ? this.$page.props.user.profile_image_path : 'https://www.gravatar.com/avatar/94d093eda664addd6e450d7e9881bcad?s=32&d=mp&r=PG'
		}
	},

	watch: {
		wtfOwner: function (value) {
			if (!value) return
			this.initToolTip('wtf-owner-tooltip')
		}
	}
}
</script>
